"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const fa_1 = require("react-icons/fa");
const usePanelPreferences_1 = require("../../hooks/usePanelPreferences");
const useTableSortBy_1 = __importDefault(require("../../hooks/useTableSortBy"));
const ZonesTableRow_1 = __importDefault(require("./ZonesTableRow"));
const useMapZones_1 = require("./hooks/useMapZones");
const NoDataForFid_1 = __importDefault(require("../extra/placeholder/NoDataForFid"));
const NoTableData_1 = __importDefault(require("../extra/placeholder/NoTableData"));
const tableStyle = (0, react_1.css) `
  border-spacing: 0;
  border: 1px solid #dedede;
  width: 100%;
  font-size: 12px;

  .react-contextmenu-wrapper {
    display: contents;
  }

  th {
    position: sticky;
    background-color: white;
    z-index: 2;
  }

  th,
  td {
    white-space: nowrap;
    text-align: center;
    margin: 0;
    padding: 0.1rem 0.4rem;
    border-bottom: 1px solid #dedede;
    border-right: 1px solid #dedede;

    :last-child {
      border-right: 0;
    }

    button {
      background-color: transparent;
      border: none;
      padding: 0 5px;
    }
  }

  tr {
    :last-child {
      td {
        border-bottom: 0;
      }
    }
  }

  thead tr:nth-of-type(1) th {
    top: 0;
  }

  thead tr:nth-of-type(2) th {
    top: 21px;
  }
`;
function ZonesTable({ tableData, onUnlink, nucleus, info }) {
    const { experiment, isFid } = info;
    const nuclei = nucleus.split(',');
    const data = (0, useMapZones_1.useMapZones)(tableData, { nuclei, experiment });
    const { items: sortedData, isSortedDesc, onSort } = (0, useTableSortBy_1.default)(data);
    const { deltaPPM: deltaX } = (0, usePanelPreferences_1.usePanelPreferences)('zones', nuclei?.[0]);
    const { deltaPPM: deltaY } = (0, usePanelPreferences_1.usePanelPreferences)('zones', nuclei?.[1]);
    const { showSerialNumber, showAssignment, showKind, showDeleteAction, showEditAction, showZoomAction, } = (0, usePanelPreferences_1.usePanelPreferences)('zones', nucleus);
    const showActions = showDeleteAction || showEditAction || showZoomAction;
    if (isFid) {
        return (0, jsx_runtime_1.jsx)(NoDataForFid_1.default, {});
    }
    if (!tableData || tableData.length === 0) {
        return (0, jsx_runtime_1.jsx)(NoTableData_1.default, {});
    }
    return ((0, jsx_runtime_1.jsx)("div", { children: (0, jsx_runtime_1.jsxs)("table", { css: tableStyle, children: [(0, jsx_runtime_1.jsxs)("thead", { children: [(0, jsx_runtime_1.jsxs)("tr", { children: [showSerialNumber && (0, jsx_runtime_1.jsx)("th", { rowSpan: 2, children: "#" }), (deltaX.show || deltaX.show) && (0, jsx_runtime_1.jsx)("th", { colSpan: 2, children: "\u03B4 (ppm)" }), showAssignment && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("th", { colSpan: 2, children: (0, jsx_runtime_1.jsx)(fa_1.FaLink, {}) }), (0, jsx_runtime_1.jsx)("th", { colSpan: 2, children: "\u03A3" })] })), showKind && (0, jsx_runtime_1.jsx)("th", { rowSpan: 2, children: "Kind" }), showActions && (0, jsx_runtime_1.jsx)("th", { rowSpan: 2, children: '' })] }), (0, jsx_runtime_1.jsxs)("tr", { children: [deltaX.show && ((0, jsx_runtime_1.jsx)("th", { id: "tableMetaInfo.signal.x.delta", ...onSort, children: (0, jsx_runtime_1.jsxs)(SurroundedText, { text: "F2", children: [nuclei[0], ' ', isSortedDesc('tableMetaInfo.signal.x.delta').content] }) })), deltaY.show && ((0, jsx_runtime_1.jsx)("th", { id: "tableMetaInfo.signal.y.delta", ...onSort, children: (0, jsx_runtime_1.jsxs)(SurroundedText, { text: "F1", children: [nuclei[1], ' ', isSortedDesc('tableMetaInfo.signal.y.delta').content] }) })), showAssignment && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("th", { children: (0, jsx_runtime_1.jsx)(SurroundedText, { text: "F2", children: nuclei[0] }) }), (0, jsx_runtime_1.jsx)("th", { children: (0, jsx_runtime_1.jsx)(SurroundedText, { text: "F1", children: nuclei[1] }) }), (0, jsx_runtime_1.jsx)("th", { children: (0, jsx_runtime_1.jsx)(SurroundedText, { text: "F2", children: nuclei[0] }) }), (0, jsx_runtime_1.jsx)("th", { children: (0, jsx_runtime_1.jsx)(SurroundedText, { text: "F1", children: nuclei[1] }) })] }))] })] }), (0, jsx_runtime_1.jsx)("tbody", { children: sortedData.map((rowData, index) => ((0, jsx_runtime_1.jsx)(ZonesTableRow_1.default, { rowIndex: index, rowData: rowData, onUnlink: onUnlink, nucleus: nucleus }, `${rowData.tableMetaInfo.id}`))) })] }) }));
}
function SurroundedText(props) {
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", { style: {
                    position: 'absolute',
                    fontSize: 8,
                    color: '#3539E6',
                }, children: props.text }), (0, jsx_runtime_1.jsx)("div", { style: { marginLeft: 5 }, children: props.children })] }));
}
exports.default = ZonesTable;
